import { Component, OnInit, HostListener } from "@angular/core";
import { Router, NavigationEnd } from "@angular/router";
import { filter } from "rxjs/operators";

@Component({ standalone: false,
  selector: "app-admin-layout",
  templateUrl: "./admin-layout.component.html",
  styleUrls: ["./admin-layout.component.scss"]
})
export class AdminLayoutComponent implements OnInit {
  isMobileResolution: boolean;
  isGrayNavbar = false;


  constructor(public router: Router) {
    if (window.innerWidth < 1200) {
      this.isMobileResolution = true;
    } else {
      this.isMobileResolution = false;
    }
  }

  @HostListener("window:resize", ["$event"])
  isMobile(event: any) {
    if (window.innerWidth < 1200) {
      this.isMobileResolution = true;
    } else {
      this.isMobileResolution = false;
    }
  }


  private updateCurrentPage(url: string): void {
    this.isGrayNavbar = [
      "/dashboard/merchant", 
      "/dashboard/admin", "/accounts", 
      "/transactions/transaction-list",
      "/transactions/form", "/audit-logs", 
      "/mid/mid-list", 
      "/features/timeline"]
      .includes(url);
  }

  ngOnInit() {
    
    // Initial load
    this.updateCurrentPage(this.router.url);

    // Update on every navigation
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.updateCurrentPage(event.urlAfterRedirects);
      });
  }
}